import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isEmbeddedTrips, notifyTripsParent } from "../utils/embeddedTrips";

export default function EmbeddedTripsBridge() {
  const location = useLocation();
  useEffect(() => {
    if (!isEmbeddedTrips) return;
    if (location.pathname !== "/all-trips") {
      notifyTripsParent("navigate", { path: location.pathname + location.search + location.hash });
    } else {
      notifyTripsParent("ready");
    }
  }, [location]);

  useEffect(() => {
    if (!isEmbeddedTrips) return;
    const onClick = event => {
      const link = event.target.closest?.("a[href]");
      if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname === "/all-trips") return;
      event.preventDefault();
      notifyTripsParent("navigate", { path: url.pathname + url.search + url.hash });
    };
    const onKey = event => {
      if (event.key === "Escape" && !event.defaultPrevented && !document.querySelector('[role="dialog"], .MuiModal-root, [data-rsbs-overlay]')) {
        notifyTripsParent("close");
      }
    };
    document.addEventListener("click", onClick);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("click", onClick);
      window.removeEventListener("keydown", onKey);
    };
  }, []);
  return null;
}
